import type { ReactNode } from "react";
import { Box, CircularProgress } from "@mui/material";

interface LoadingCenterProps {
  minHeight?: string | number;
  children?: ReactNode;
}

/** Centers a spinner (or custom content) for loading and auth gates. */
export function LoadingCenter({
  minHeight = "50vh",
  children,
}: LoadingCenterProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
      }}
    >
      {children ?? <CircularProgress />}
    </Box>
  );
}
